import React from 'react';
import { Linkedin } from 'lucide-react';
type TeamMember = {
  name: string;
  role: string;
  description?: string;
  image: string;
  // Verschiebt nur den Bildausschnitt im Kreis, nicht den Kreis selbst
  cropOffset?: {
    x?: number;
    y?: number;
  };
  // 1.15 = 15% reinzoomen
  zoom?: number;
};
export function About() {
  const team: TeamMember[] = [{
    name: 'Christopher Welz',
    role: 'B.Sc. Betriebswirtschaftslehre',
    description: '10 Jahre Startup und Software, Builder DNA',
    image: 'https://cdn.magicpatterns.com/uploads/k3G5QU8BQKBcyDzbQwxETw/Christopher_Welz.jpg',
    cropOffset: {
      y: 40
    },
    // Chris 40px weiter unten im Ausschnitt
    zoom: 1
  }, {
    name: 'Daniel Felser',
    role: 'M.Sc. Wirtschaftsinformatik',
    description: 'Creative Technologist und Experte für generative KI Lösungen',
    image: 'https://cdn.magicpatterns.com/uploads/7KDWptnZ5u5wtLwzVzgkdC/Daniel_Felser.png',
    cropOffset: {
      x: 0,
      y: 0
    },
    zoom: 1.2 // Daniel 20% reinzoomen
  }];
  return <section id="about" className="py-24 bg-white border-t border-neutral-100" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl font-semibold text-black mb-4" data-id="element-17">
            Hi, wir sind Archaitechs.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-18">
          {team.map(member => {
          const x = member.cropOffset?.x ?? 0;
          const y = member.cropOffset?.y ?? 0;
          const zoom = member.zoom ?? 1;
          return <div key={member.name} className="flex flex-col items-center text-center group" data-id="element-19">
                <div className="relative mb-6" data-id="element-20">
                  <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-white shadow-lg relative z-10" data-id="element-21">
                    <div className="w-full h-full transition-transform duration-500 group-hover:scale-105" data-id="element-22">
                      <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                    objectPosition: `calc(50% + ${x}px) calc(50% + ${y}px)`,
                    transform: `scale(${zoom})`,
                    transformOrigin: 'center'
                  }} data-id="element-23" />
                    </div>
                  </div>

                  {/* Decorative circle behind */}
                  <div className="absolute inset-0 bg-neutral-50 rounded-full scale-110 -z-0 group-hover:scale-125 transition-transform duration-500" data-id="element-24"></div>
                </div>

                <h3 className="text-xl font-semibold text-black mb-1" data-id="element-25">
                  {member.name}
                </h3>
                <p className="text-sm font-medium text-black mb-2" data-id="element-26">
                  {member.role}
                </p>
                {member.description && <p className="text-neutral-500 font-light max-w-xs" data-id="element-27">
                    {member.description}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}